import React from 'react';
import './buttons.css'

const ShareButton = ({ title, description, url }) => {
  const handleShareButtonClick = async () => {
    try {
      await navigator.share({
        title: title,
        text: description,
        url: url
      });
      console.log('Contenido compartido con éxito');
    } catch (error) {
      console.error('Error al compartir:', error);
    }
  };

  return (
    <button onClick={handleShareButtonClick} className="menuItems-btn">
        <img src={process.env.PUBLIC_URL+"/img/share.png"} alt=" WhatsApp"/> 
        Compartir</button>
  );
};

export default ShareButton;
